
import React, { useMemo } from 'react';
import { Inscription } from '@common-fe/common-fe';
import { capitalize } from 'lodash';

import { REGEXPS } from '@/common';
import getYearsOldTitle from '@/utils/modifiers/getYearsOldTitle';

interface Props {
  birthOn: string;
  relationship?: string;
}

const DependentsAge: React.FC<Props> = ({ birthOn, relationship }) => {
  const relationshipTitle = useMemo(() => relationship
    ? `${capitalize(relationship.replace(REGEXPS.DASH_SYMBOL, ' '))}, `
    : '', [relationship]);

  return (
    <Inscription
      size="large"
      color="textSecondary"
      margin={{ left: 'spacing4' }}
      data-testId="DependentsAge"
    >
      ({relationshipTitle}{getYearsOldTitle(birthOn)})
    </Inscription>
  );
};

export default DependentsAge;
